<div class="bank-account" (click)="onClickList(bank)">
  <comp-icon class="bank-icon" [icon]="'account_balance'" [color]="'#2383e2'" [size]="18"></comp-icon>
  <div>{{bank.bank_name}}</div>
  <div style="padding-left: 20px">****{{bank.last4}}</div>
  <div class="default-label" *ngIf="defaultPaymentId === bank.payment_method_id">Default</div>
</div>